export default Object.freeze({
  HEADER_TITLE: '적립금 관리',
  GRIDS_HEADER_IS_EDITABLE: '수정',
  GRIDS_HEADER_MALL_NAME: '쇼핑몰',
  GRIDS_HEADER_ACCUMULATION_RATE: '기본적립률',
  GRIDS_HEADER_ACCUMULATION_NAME: '적립금명칭',
  GRIDS_HEADER_SING_UP_ACCUMULATION: '회원가입 적립금',
  GRIDS_HEADER_REVIEW_ACCUMULATION: '상품평 적립금',
  GRIDS_HEADER_PHOTO_REVIEW_ACCUMULATION: '포토상품평 적립금',
  GRIDS_HEADER_BIRTHDAY_ACCUMULATION: '생일자 회원 적립금',
  GRIDS_HEADER_APP_INSTALL_ACCUMULATION: '앱설치 적립금',
  GRIDS_HEADER_ACCUMULATION_USE_MIN_PRODUCT_PRICE: '적립금 사용 최소 결제금액',
  GRIDS_HEADER_ACCUMULATION_USE_MIN_PRICE: '적립금 사용 최소 적립금',
  GRIDS_HEADER_ACCUMULATION_USE_MAX_RATE: '적립금 사용 최대 적립금',
  GRIDS_HEADER_ACCUMULATION_GIVE_POINT: '적립금 지급 시점',
  GRIDS_EXPIRE_ACCUMULATION_VALID_PERIOD: '적립금 유효기간',
  GRIDS_HEADER_EXPIRED_NOTIFICATION_POINT: '적립금 만료알림',
  GRIDS_HEADER_REGISTER_YMDT: '등록일시',
  GRIDS_HEADER_UPDATE_ADMIN: '최종 수정자',
  GRIDS_HEADER_UPDATE_YMDT: '최종수정일',
  GRIDS_SINGUP_ACCUMULATION_DISABLE: '사용안함',
  EDIT: '수정',

  ACCUMULATION_POINT_TEXT: '구매확정 후',
  ACCUMULATION_POIN_IMMEDIATE: '즉시',
  ACCUMULATION_POIN_NEXTDAY: '익일',
  ACCUMULATION_POIN_DAY_AFTER_TOMMOROW: '(2)일',
  ACCUMULATION_POIN_AFTER_A_WEEK: '(7)일',
  ACCUMULATION_POIN_AFTER_TWO_WEEK: '(14)일',
  ACCUMULATION_POIN_AFTER_TWENTY_DAYS: '(20)일',
  ACCUMULATION_POIN_AFTER_THIRTY_DAYS: '(30)일',
  ACCUMULATION_POIN_NEXT_MONTH: '익월',

  NO_LIMIT: '제한없음',
  OUT_LIMIT: '원 이상 구매 시',
  WORDS_TEXT: '자 이상',
  PAYMENT_UNIT: '적립',
  TOTAL_PAYMENT: '결제금액 합계',
  PAY_TIME: '지급일 기준',
  YEAR: '년',
  MOUNTH: '개월',
  EXPIRE_TEXT: '만료일 기준 {day}일 전',
  PRICE_UNIT: '부터',

  NO_DATA: '해당 서비스에 쇼핑몰이 존재하지 않습니다.'
});
